import validate from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/node_modules/.pnpm/nuxt@3.13.2_@types+node@18.19.54_typescript@5.6.2_vite@5.4.8_vue-tsc@2.1.6/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/middleware/auth.global.ts";
import manifest_45route_45rule from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/node_modules/.pnpm/nuxt@3.13.2_@types+node@18.19.54_typescript@5.6.2_vite@5.4.8_vue-tsc@2.1.6/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}